import React from "react";
import styled from "styled-components";

import lineIcon from "assets/images/png/icon-line.png";
import clockIcon from "assets/images/png/icons-clock.png";
import locationIcon from "assets/images/png/icons-location.png";
import officeIcon from "assets/images/png/icons-office-phone.png";
import phoneIcon from "assets/images/png/icons-phone.png";
import websiteIcon from "assets/images/png/icons-website.png";
import emailIcon from "assets/images/svg/icon-email.svg";
import facebookIcon from "assets/images/svg/icon-facebook.svg";
import instagramIconW from "assets/images/svg/icon-instagram-while.svg";
import instagramIcon from "assets/images/svg/icon-instagram.svg";

import locationIconW from "assets/images/png/icon-location-while.png";
import emailIconW from "assets/images/svg/icon-email-while.svg";
import facebookIconW from "assets/images/svg/icon-facebook-while.svg";
import officeIconW from "assets/images/svg/icons-office-phone-while.svg";
import phoneIconW from "assets/images/svg/icons-phone-while.svg";
import websiteIconW from "assets/images/svg/icons-website-while.svg";

import clockIconW from "assets/images/png/icon-clock-while.png";
import lineIconW from "assets/images/png/icon-line-while.png";

const DetailContact = (props) => {
  const {
    title,
    title0,
    phone,
    office,
    website,
    location,
    time,
    email1,
    email2,
    email3,
    email4,
    facebook,
    line,
    color,
    indent,
    slang,
    type,
    address,
    indentAddress,
    titleWebsite,
    index,
    nameFB,
    IG,
    nameIG,
  } = props;

  const spliteText = (text) => {
    const newText = text.split(",");

    const data =
      newText &&
      newText.map((item) => {
        return (
          <>
            {item} <br />
          </>
        );
      });
    return data;
  };

  return (
    <>
      {title && (
        <Contact indent={indent} color={color}>
          {slang === "department-dentistry" ||
          slang === "doctor-of-dental-surgery"
            ? spliteText(title)
            : title}
        </Contact>
      )}
      
      {phone && (
        <Contact color={color}>
          <img
            src={color === "white" ? phoneIconW : phoneIcon}
            alt="icon phone"
            loading="lazy"
          />
          {phone}
        </Contact>
      )}
      {office && (
        <Contact color={color}>
          <img
            src={color === "white" ? officeIconW : officeIcon}
            alt="icon office"
            loading="lazy"
          />
          {office}
        </Contact>
      )}
      {time && (
        <Contact color={color}>
          <img
            src={color === "white" ? clockIconW : clockIcon}
            alt="icon clock"
            loading="lazy"
          />
          {time}
        </Contact>
      )}
      {facebook && (
        <Contact color={color}>
          <img
            src={color === "white" ? facebookIconW : facebookIcon}
            alt="icon facebook"
            loading="lazy"
          />
          {slang === "department-public-health" ? (
            <>
              {type === "department" ? (
                <a
                  href={facebook}
                  target="_blank"
                  rel="noreferrer"
                  className="link-web"
                >
                  {nameFB ? nameFB : "เฟซบุ๊กสำนักวิชา"}
                </a>
              ) : (
                <a
                  href={facebook}
                  target="_blank"
                  rel="noreferrer"
                  className="link-web"
                >
                  {index === 0
                    ? "ENVI Health SUT"
                    : index === 1
                    ? "สาขาวิชาอาชีวอนามัยเเละความปลอดภัย มหาวิทยาลัยเทคโนโลยีสุรนารี"
                    : index === 2
                    ? "Nutrition & Dietetics SUT"
                    : "เฟซบุ๊กสาขาวิชา"}
                </a>
              )}
            </>
          ) : (
            <>
              {type === "department" ? (
                <a
                  href={facebook}
                  target="_blank"
                  rel="noreferrer"
                  className="link-web"
                >
                  เฟซบุ๊กสำนักวิชา
                </a>
              ) : (
                <a
                  href={facebook}
                  target="_blank"
                  rel="noreferrer"
                  className="link-web"
                >
                  เฟซบุ๊กสาขาวิชา
                </a>
              )}
            </>
          )}
        </Contact>
      )}
      {website && (
        <Contact color={color}>
          <img
            src={color === "white" ? websiteIconW : websiteIcon}
            alt="icon website"
            loading="lazy"
          />
          {type === "department" ? (
            <a
              className="link-web"
              href={website}
              target="_blank"
              rel="noreferrer"
            >
              เว็บไซต์สำนักวิชา
            </a>
          ) : type === "branch" ? (
            <a
              className="link-web"
              href={website}
              target="_blank"
              rel="noreferrer"
            >
              {titleWebsite ? titleWebsite : "เว็บไซต์สาขาวิชา"}
            </a>
          ) : (
            <a
              className="link-web"
              href={website}
              target="_blank"
              rel="noreferrer"
            >
              เว็บไซต์ศูนย์บริการการศึกษา
            </a>
          )}
        </Contact>
      )}
      {line && (
        <Contact color={color}>
          <img
            src={color === "white" ? lineIconW : lineIcon}
            alt="icon line"
            loading="lazy"
          />
          {line}
        </Contact>
      )}
      {email1 && (
        <Contact color={color}>
          <img
            loading="lazy"
            src={color === "white" ? emailIconW : emailIcon}
            alt="icon email"
            style={{ width: "24px" }}
          />
          {email1}
        </Contact>
      )}
      {email2 && (
        <Contact color={color}>
          <img
            loading="lazy"
            src={color === "white" ? emailIconW : emailIcon}
            alt="icon email"
            style={{ width: "24px" }}
          />
          {email2}
        </Contact>
      )}
      {email3 && (
        <Contact color={color}>
          <img
            loading="lazy"
            src={color === "white" ? emailIconW : emailIcon}
            alt="icon email"
            style={{ width: "24px" }}
          />
          {email3}
        </Contact>
      )}
      {location && (
        <Contact color={color}>
          <img
            loading="lazy"
            src={color === "white" ? locationIconW : locationIcon}
            alt="icon location"
          />
          {location}
        </Contact>
      )}
      {address && (
        <Contact color={color}>
          <img
            loading="lazy"
            src={color === "white" ? locationIconW : locationIcon}
            alt="icon location"
          />
          {address}
        </Contact>
      )}
      {IG && nameIG && (
        <Contact color={color}>
          <img
            src={color === "white" ? instagramIconW : instagramIcon}
            alt="icon website"
            loading="lazy"
          />
          <a href={IG} target="_blank" rel="noreferrer" className="link-web">
            {nameIG}
          </a>
        </Contact>
      )}
      {/* เดิมคุณอาจจะเขียนไว้แบบนี้ ให้เติม style={...} เข้าไปครับ */}
{title0 && (
  <Contact indent={indent} color={color} style={{ marginTop: '20px' }}>
    {title0}
  </Contact>
)}
      
      {/* ------------------------- */}
      {email4 && (
        <Contact color={color}>
          <img
            loading="lazy"
            src={color === "white" ? emailIconW : emailIcon}
            alt="icon email"
            style={{ width: "24px" }}
          />
          {email4}
        </Contact>
      )}
      
    </>
  );
};

export default DetailContact;

const Contact = styled.p`
  font-family: "Noto Sans Thai";
  text-align: left;
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 35px;
  margin-bottom: 0;
  margin-left: 30px;
  text-indent: ${(props) => (props.indent ? `${props.indent}px` : "0")};
  word-break: break-word;
  display: flex;

  color: ${(props) => (props.color ? props.color : "var(--black)")};

  img {
    margin-right: 18px;
    height: 24px;
    margin-top: 5px;
  }

  @media only screen and (max-width: 1024px) and (orientation: portrait) {
    line-height: 30px;
  }

  .link-web {
    display: block;

    color: ${(props) =>
      props.color ? props.color : "var(--black)"} !important;

    margin-left: 0 !important;

    &:hover {
      color: var(--secondary) !important;
    }
  }
`;
